<!--
create by melody on 2018/11/1
description:期间管理页面
-->
<template>
    <div>
        <page-header :title="title"></page-header>
        <!-- 期间管理*****主页面 -->
        <template v-if = "!isShowEdit">
            <div class="search-container hdp-w-100">
                <div class="hdp-uf hdp-w-100">
                    <div class="hdp-uf hdp-uf-vc">{{$t('m.primaryLedger')}}：</div>
                    <el-select filterable v-model="searchParam.primaryLedgerId" @change="getDemoList()" :placeholder="$t('m.primaryLedger')" style="width:25%;margin-left:10px;margin-right:5%;" clearable>
                        <el-option v-for="(item, index) in accountList" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <lap-search-btn :searchParam="searchParam" @successMethod="getDemoList()"></lap-search-btn>
                    <!-- <el-button type="primary" style="margin-left:5%;" @click="getDemoList()">
                        <div class="hdp-uf hdp-uf-hc hdp-uf-vc">
                            <img width="14px" src="../../assets/images/btn-icon-filter.png">
                            <p>&nbsp;&nbsp;筛 选</p>
                        </div>
                  </el-button> -->
                </div>
            </div>
            <div class="table-container">
                <el-button type="primary" icon="el-icon-plus" plain @click="addFiscalYear()" v-if="buttonList.includes('1')"> {{$t("m.add")}} </el-button>
               <!--  <el-button type="info" icon="el-icon-delete" plain @click="handleDelete('batch')" v-if="buttonList.includes('3')"> {{$t("m.delete")}} </el-button> -->
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    stripe
                    tooltip-effect="dark"
                    style="width: 100%;margin: 24px 0"
                    @select="handleSelect"
                    @select-all="handleSelectAll"
                    >
                    <el-table-column
                        type="selection"
                        width="35">
                    </el-table-column>
                    <el-table-column
                        type="index">
                    </el-table-column>
                    <el-table-column
                        :label="$t('m.fiscalYear')">
                         <template  slot-scope="scope">
                            <span class="span-style" @click="handleEdit(scope.row)">{{scope.row.fiscalYear}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="startDate"
                        :label="$t('m.startDate')"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="endDate"
                        :label="$t('m.endDate')"
                        show-overflow-tooltip>
                    </el-table-column>
                    <!-- <el-table-column
                        label="操作"
                        align="right" width="150">
                        <template slot-scope="scope">
                            <el-button type="danger" icon="el-icon-delete" size='mini' plain @click="handleDelete('single', scope.row)"  v-if="buttonList.includes('3')"></el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <lap-pagination :total="total" :searchParam="searchParam" @successMethod="getDemoList()"></lap-pagination>
            </div>
        </template>
        <!-- 期间管理******编辑页面 -->
        <template v-else = "isShowEdit">
            <div class="table-container">
                <p>
                    <el-button type="text" icon="el-icon-arrow-left" @click="isShowEdit = false">{{$t('m.back')}}</el-button>
                </p>
                <div class="hdp-uf psc-bg-info2 psc-font-4" style="margin-top:24px;padding:10px;">{{yearNameFlag}} {{$t('m.fiscalYear')}}</div>
                <el-table
                    ref="multipleTable"
                    :data="tableData2"
                    stripe
                    tooltip-effect="dark"
                    style="width: 100%;margin: 24px 0"
                    >
                    <el-table-column
                        type="index"
                        label="#">
                    </el-table-column>
                    <el-table-column
                        :label="$t('m.fiscalYear')"
                        prop="fiscalYear">
                    </el-table-column>
                    <el-table-column
                        prop="periodNum"
                        :label="$t('m.periodNum')">
                    </el-table-column>
                    <el-table-column
                        prop="startDate"
                        :label="$t('m.startDate')">
                    </el-table-column>
                    <el-table-column
                        prop="endDate"
                        :label="$t('m.endDate')">
                    </el-table-column>
                    <el-table-column
                        prop="periodStatus"
                        :label="$t('m.periodStatus')">
                        <template slot-scope="scope">
                            <span>{{scope.row.periodStatus == 1 ? $t('m.periodStatus1') : scope.row.periodStatus == 2 ? $t('m.periodStatus2') : scope.row.periodStatus == 3 ? $t('m.periodStatus3') : '' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t('m.periodStatusEdit')"
                        align="right" width="150">
                        <template slot-scope="scope">
                            <el-button icon="el-icon-edit-outline" size='mini' plain @click="handleEditPeriod(scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </template>
        <!-- add Form -->
        <el-dialog
            :title="$t('m.add')"
            :visible.sync="dialogVisible"
            v-if="dialogVisible"
            width="30%">
            <div style="margin-left: 10%">
                <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                    <el-form-item :label="$t('m.fiscalYear')" prop="fiscalYear" >
                        <el-date-picker
                            style="width:80%;"
                            v-model="form.fiscalYear"
                            type="year"
                            value-format="yyyy"
                            :picker-options="pickerOptions0"
                            :placeholder="$t('m.fiscalYear')">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('m.startMonth')" prop="startDate">
                        <el-select v-model="form.startDate" :disabled="!isNoYearFlag" placeholder="起始月" style="width:80%;">
                            <el-option label="1" :value="1"></el-option>
                            <el-option label="2" :value="2"></el-option>
                            <el-option label="3" :value="3"></el-option>
                            <el-option label="4" :value="4"></el-option>
                            <el-option label="5" :value="5"></el-option>
                            <el-option label="6" :value="6"></el-option>
                            <el-option label="7" :value="7"></el-option>
                            <el-option label="8" :value="8"></el-option>
                            <el-option label="9" :value="9"></el-option>
                            <el-option label="10" :value="10"></el-option>
                            <el-option label="11" :value="11"></el-option>
                            <el-option label="12" :value="12"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('m.periodStatus')" prop="periodStatus">
                        <el-select v-model="form.periodStatus" style="width:80%;">
                            <el-option :label="$t('m.periodStatus1')" value="1"></el-option>
                            <el-option :label="$t('m.periodStatus2')" value="2"></el-option>
                            <el-option :label="$t('m.periodStatus3')" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="addDisable" @click="addDemo()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- Edit Proid Form -->
        <el-dialog
            :title="$t('m.periodStatusEdit')"
            :visible.sync="dialogProidFormVisible"
            v-if="dialogProidFormVisible"
            width="30%">
            <div style="margin-left: 10%">
                <el-form :model="lineForm">
                    <el-form-item :label="$t('m.periodStatus')" label-width="100px">
                        <el-select v-model="lineForm.periodStatus" style="width:80%;">
                            <el-option :label="$t('m.periodStatus1')" :value="1"></el-option>
                            <el-option :label="$t('m.periodStatus2')" :value="2"></el-option>
                            <el-option :label="$t('m.periodStatus3')" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogProidFormVisible = false">{{$t('m.cancel')}}</el-button>
                <el-button type="primary" @click="modifyDemoLine()">{{$t('m.sure')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

export default {
    data() {
        let minFiscalYear = '2018' //最小财年
        return {
            buttonList: ['1', '3'],
            title: {
                firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.CONFIG_MANAGE'),
                thirdTitle: this.$t('m.PERIOD_MANAGE')
            },
            accountList: [],
            searchParam: {      //查询参数
                primaryLedgerId: '',
                pageSize: 10,
                pageNum: 1,
            },
            form: {
                primaryLedgerId: '',
                fiscalYear: '',
                startDate: '',
                // endDate: '',
                periodStatus: ''
            },
            lineForm: {     //弹框内容
                periodId: '',
                periodStatus: ''
            },
            rules: this.$ruleApi.getRule('year'),
            //开始日期：当前日期后和结束日期后不可勾选
            pickerOptions0: {
                disabledDate: (time) => {
                    var d = new Date(minFiscalYear);
                    return time.getTime() < d.getTime()
                },
            },
            tableData: [],
            total: 0,
            tableData2: [],
            dialogVisible: false,
            dialogProidFormVisible: false,
            isShowEdit:false,
            yearIdFlag: '', //财年idf flag
            yearNameFlag: '',//财年名字的flag
            isNoYearFlag: false, //没有财年
            deleteDemoIdArr: [],
            addDisable: false
        }
    },
    computed: {
        ...mapState({
            resDataObj: state => state.periodManage.mockData
        }),
        ...mapGetters({
            resData: 'periodManage/getMockData'
        })
    },
    methods: {
        //获得财年
        getDemoList() {
            this.$commonFunc.commonRequest('get', '/config/period/getConfigPeriodList', 'getYearList', this.searchParam)
            .then(res=>{
                if(res.obj.list && res.obj.list.length>0) {
                    this.tableData = res.obj.list
                    this.total = res.obj.total
                } else {
                    this.tableData = []
                    this.$message.info(this.$t('m.ledgerNoData'))
                }

            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //获得财年下的期间列表
        getDemoLineList() {
            this.$commonFunc.commonRequest('get', '/config/period/getFiscalYearConfigPeriodList', 'getYearPeriodList', {primaryLedgerId: this.searchParam.primaryLedgerId, periodId: this.yearIdFlag})
            .then(res=>{
                this.tableData2 = res.obj
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //获得主账套列表
        getAccountList(code) {
            this.$commonFunc.commonRequest('get', '/configValuesetLine/query/contentList', 'getValueSetLineByCode', {valuesetCode: code})
            .then(res=>{
                res.obj.forEach((o,i)=>{
                    this.accountList.push({label:o.valuesetLineContent, value:o.valuesetLineId})
                })
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        addDemo() {
            this.addDisable = true
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.form.primaryLedgerId = this.searchParam.primaryLedgerId
                    let startDateFlag = this.form.startDate
                    this.form.startDate = this.form.fiscalYear + '-' + this.form.startDate + '-01'
                    this.$commonFunc.commonRequest('post', '/config/period/addConfigPeriod', 'addYear', this.form)
                    .then(res=>{
                        this.$message.success(this.$t('m.addSuccess'));
                        this.addDisable = false
                        this.dialogVisible = false
                        this.getDemoList()
                    })
                    .catch(res=>{
                        this.$message.error(res.message)
                        this.form.startDate = startDateFlag
                        this.addDisable = false
                    })
                } else {
                    return false;
                }
            });

        },
        modifyDemoLine() {
            this.$commonFunc.commonRequest('post', '/config/period/updatedConfigPeriod', 'modifyYearPeroid', this.lineForm)
            .then(res=>{
                this.$message.success(this.$t('m.modifySuccess'));
                this.dialogProidFormVisible = false
                this.getDemoLineList()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        handleDelete(type,row) {
            if( type == 'batch' && this.deleteDemoIdArr.length == 0) {
                this.$message.info(this.$t('m.chooseDelete'))
                return 
            }
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                let demoIds = []
                if (type == 'single') {
                    demoIds.push(row.periodId)
                } else {
                    demoIds = this.deleteDemoIdArr
                }
                this.$commonFunc.commonRequest('post', '/config/period/batchDeleteConfigPeriod', 'deleteYear', {primaryLedgerId: this.searchParam.primaryLedgerId, periodIds: demoIds })
                .then(res=>{
                    this.$message.success(this.$t('m.deleteSuccess'))
                    this.deleteDemoIdArr = []
                    this.getDemoList()
                })
                .catch(res=>{
                    this.$message.error(res.message)
                })
            })
        },
        addFiscalYear() {
            if(!this.searchParam.primaryLedgerId) {
                this.$message.info(this.$t('m.chooseLedger'))
            } else {
                this.form.fiscalYear = ''
                this.form.startDate = ''
                this.form.periodStatus = ''
                this.dialogVisible = true
                this.$commonFunc.commonRequest('get', '/config/period/getFiscalYear', 'getFiscalYear', {primaryLedgerId: this.searchParam.primaryLedgerId} )
                .then(res=>{
                    if(res.obj.startDate) {
                        this.form.fiscalYear = '',
                        this.form.periodStatus = ''
                        this.form['startDate'] = Number(res.obj.startDate)
                        this.isNoYearFlag = false
                    } else {
                        this.isNoYearFlag = true
                       
                    }
                })
                .catch(res=>{
                    this.$message.error(res.message)
                })
            }
        },
        handleEdit (row) {
            this.isShowEdit = true
            this.yearIdFlag = row.periodId
            this.yearNameFlag = row.fiscalYear
            this.getDemoLineList()
        },
        handleEditPeriod (row){
            this.dialogProidFormVisible = true
            this.lineForm["periodId"] = row.periodId
            this.lineForm["periodStatus"] = row.periodStatus
        },
        //处理单选
        handleSelect(row) {
            this.deleteDemoIdArr = []
            if(row.length) {
                for(var i = 0; i < row.length; i++) {
                    this.deleteDemoIdArr.push(row[i].periodId)
                }
            }
        },
        //处理全选
        handleSelectAll(selection) {
            this.deleteDemoIdArr = []
            if(selection.length) {
                for(var i = 0; i < selection.length; i++) {
                    this.deleteDemoIdArr.push(selection[i].periodId)
                }
            }
        },
        getButtonList(firstMenu,seccondMenu) {
            let authorityList = this.$store.state.userInfo.userInfoObj.authorityList
            authorityList.forEach((o, i)=> {
                if(o.menuCode == firstMenu) {
                    o.childrenList.forEach((o2,i2)=>{
                        if(o2.menuCode == seccondMenu && o2.buttonList.length) {
                            let arr = []
                            o2.buttonList.forEach((o3,i3)=> {
                                arr.push(o3.buttonCode)
                            })
                            this.buttonList = arr
                        }
                    })
                }
            })
        }
    },
    mounted() {
        this.getAccountList(this.$valueSetObj.MAIN_ACCOUNT)
        let userInfoObj = this.$store.state.userInfo.userInfoObj
        // this.getButtonList('CONFIG_MANAGE','PERIOD_MANAGE')
        console.log(userInfoObj, 416)
    }
}
</script>
<style scoped lang="scss">
.search-container {
    background: #ffffff;
    padding: 20px;
}
.table-container {
    padding: 24px;
    margin: 32px 0;
    background: #ffffff;
}
.block {
    text-align: right;
}
.el-form-item .el-form-item__content{
    margin-left: 10px !important;
}
.span-style {
    color: #409EFF;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/config/PeriodManage.vue